export default "__VITE_ASSET__B3YAV3Kd__"